/* These lines of code are defining constants for action types in a Redux application. */
export const UPLOAD_MY_FRAME_IMAGES = 'UPLOAD_MY_FRAME_IMAGES';
export const UPLOAD_MY_FRAME_IMAGES_SUCCESS = 'UPLOAD_MY_FRAME_IMAGES_SUCCESS';
// export const LIST_ALL_FRAME_TYPES_REQUEST = 'LIST_ALL_FRAME_TYPES_REQUEST';
// export const LIST_ALL_FRAME_TYPES_FAILURE = 'LIST_ALL_FRAME_TYPES_FAILURE';
